import React from 'react'
import Text from '../text/Text'

type ButtonType = 'black' | 'border' | 'red' | 'cancel' | 'blue' | 'white' | 'primary' | 'gray' | 'leader'
type ButtonSize = 'big' | 'medium' | 'small'

interface IProps {
    className?: string
    textClassName?: string
    onClick?: any
    text?: any
    disabled?: boolean
    type?: ButtonType
    size?: ButtonSize
    inlineStyle?: any
    inlineTextStyle?: any
    onMouseEnter?: () => void
    onMouseLeave?: () => void
}

const WizButton: React.FC<IProps> = ({
    className,
    onClick,
    text,
    disabled,
    type = 'black',
    size = 'medium',
    textClassName,
    inlineStyle,
    inlineTextStyle,
    onMouseEnter,
    onMouseLeave,
}) => {
    const buttonBgColor = () => {
        if (disabled) {
            return 'bg-bg_gray01'
        }
        switch (type) {
            case 'black':
                return 'bg-black hover:bg-font01 '
            case 'border':
                return 'bg-white border border-line01 hover:bg-bg_gray01'
            case 'cancel':
                return 'bg-bg_gray01 hover:bg-line02'
            case 'red':
                return 'bg-font_red hover:brightness-[1.1]'
            case 'blue':
                return 'bg-sub_blue hover:bg-tag_blue'
            case 'primary':
                return 'bg-primary hover:brightness-[1.1]'
            case 'white':
                return 'bg-white hover:bg-bg_gray02'
            case 'gray':
                return 'bg-font04  hover:bg-font03'
            case 'leader':
                return 'bg-golden_brown hover:brightness-[1.1]'
        }
    }

    const textColor = () => {
        if (disabled) {
            return 'text-font02'
        }
        switch (type) {
            case 'black':
                return 'text-white'
            case 'border':
                return 'text-font01'
            case 'cancel':
                return 'text-font02'
            case 'red':
                return 'text-white'
            case 'blue':
                return 'text-white'
            case 'primary':
                return 'text-white'
            case 'white':
                return 'text-font02  hover:text-font01'
            case 'gray':
                return 'text-white'
            case 'leader':
                return 'text-white'
        }
    }
    const buttonSize = () => {
        switch (size) {
            case 'big':
                return 'px-[40px] py-[12px] text-body1 rounded-[5px] '
            case 'medium':
                return 'px-[20px] py-[10px] rounded-[5px] text-body2'
            case 'small':
                return 'px-[20px] py-[7px] rounded-[5px] text-body2'
        }
    }
    return (
        <button
            style={{...inlineStyle}}
            className={`whitespace-nowrap ${buttonSize()} ${buttonBgColor()} ${className}`}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            disabled={disabled}>
            <Text inlineStyle={{...inlineTextStyle}} className={`${textColor()} ${textClassName}`}>
                {text}
            </Text>
        </button>
    )
}

export default WizButton
